import { useEffect, useState } from 'react';
import { FunnelChart, Funnel, Tooltip, Legend } from 'recharts';

// Custom Legend Component
const CustomizedLegend = ({ data }) => {
  return (
    <div className="piplinechart">
      <ul style={{ listStyleType: 'none', padding: 0 }}>
        {data.map((entry, index) => (
          <li
            key={`item-${index}`}
            style={{
              marginBottom: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
            className="list-chart"
          >
            {/* Colored square for legend item */}
            <div
              style={{
                width: 50,
                height: 2,
                backgroundColor: entry.fill,
                marginRight: 10,
                marginLeft: 10,
              }}
            ></div>
            {/* Display name and value */}
            <span>{`${entry.name}: ${entry.value}`}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

// Predefined colors array
const colors = ['#B7BCFF', '#9adef4', '#9af4de', '#a2f0b5', '#f4ed9a', '#f9cea9', '#ffbfbf'];

const PipelineDealsByStage = ({ apiData }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const sortedData = [...apiData].sort((a, b) => a.sequence - b.sequence);

    const dataWithColors = sortedData.map((item, index) => ({
      ...item,
      fill: colors[index % colors.length], // Assign color based on index
      name: item.stageName,
      value: item.stageCount,
    }));

    setData(dataWithColors);
  }, [apiData]); // ✅ include apiData in dependency array

  return (
    <>
      <FunnelChart width={250} height={200}>
        <Tooltip />
        <Funnel dataKey="value" nameKey="name" data={data} isAnimationActive></Funnel>
      </FunnelChart>
      {data.length > 0 && <Legend content={<CustomizedLegend data={data} />} />}
    </>
  );
};

export default PipelineDealsByStage;
